module.exports = __webpack_public_path__ + "static/media/we-left-top.582e43fe.png";